import * as yup from 'yup'

const schema = yup.object().shape({
  name: yup.string().required('Nome é obrigatório'),
  price: yup.string().required('Valor sugerido é obrigatório'),
  governanceProjectTemplateId: yup.string().when('isGovernanceReviewType', {
    is: true,
    then: yup
      .string()
      .required('Selecione o projeto de governança (template).'),
  }),
})

export default schema
